import React from 'react'
import Radium from 'radium'
import Cookies from 'js-cookie'
import Color from 'color'
import { colors, spacing, shadows } from './assets/shibui';
import Dismiss from './assets/dismiss.svg'

const STYLES = {
  announcementWrap: {
    backgroundColor: colors.amethystMuted.color,
    width: '100%',
    textAlign: 'center',
    zIndex: 3,
    position: 'absolute',
    top: 69,
    padding: '15px 40px',
    left: '50%',
    transform: 'translateX(-50%)',
    '@media screen and (max-width: 700px)': {
      transform: 'translateX(0)',
      width: '100%',
      position: 'fixed',
      top: 'auto',
      bottom: 0,
      left: 0,
      paddingLeft: 10,
      paddingRight: 10,
      backgroundColor: colors.ivory.color,
      color: colors.midnight.color,
      boxShadow: shadows.card.boxShadow
    },
  },
  altBG: {
    backgroundColor: Color(colors.midnight.color).fade(.77),
  },
  dismisser: {
    position: 'absolute',
    top: '50%',
    right: 35,
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  text: {
    color: Color(colors.ivory.color).fade(.13),
    fontSize: 15,
    textDecoration: 'none',
    textTransform: 'none',
    '@media screen and (max-width: 700px)': {
      color: colors.midnight.color
    },
  },
  link: {
    fontWeight: 700,
    color: colors.tiger40.color,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    textTransform: 'inherit',
    background: 'none',
    border: 'none',
    padding: 0,
    letterSpacing: .84,
    marginLeft: spacing.xs
  },
  emoji: {
    transform: 'translateY(2px)',
    display: 'inline-block'
  }
}

const BANNER_COOKIE = 'banner_cookie'

class NotificationManager extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isEuropeanUnion: false,
      hasAcceptedCookies: this.hasUserAcceptedCookies(),
      isAlertVisible: false,
    }
  }

  componentDidMount() {
    const isAlertVisible = sessionStorage
      ? !sessionStorage.getItem('alertDismissed')
      : true
    this.setState({ isAlertVisible })

    if (!this.state.hasAcceptedCookies) {
      this.checkIfIsEuropeanUnion()
    }
  }

  checkIfIsEuropeanUnion() {
    if (process.env.ALWAYS_SHOW_COOKIE_BANNER === 'true') {
      return this.setState({isEuropeanUnion: true});
    }

    // NOTE: since we are using a hackish solution to fetch this information we
    // decided to not include this logic in sdk-inkstone.
    const request = new XMLHttpRequest()
    request.open(
      'GET',
      'https://inkstone-edge.haiku.ai/v0/integrations/cloudfront/geolocation',
      true
    )

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText)
        this.setState({isEuropeanUnion: data.IsEuropeanUnion})
      }
    }

    request.onerror = () => {
      this.setState({isEuropeanUnion: true})
    }

    request.send()
  }

  setCookieAsAccepted() {
    Cookies.set(BANNER_COOKIE, true, {
      domain: process.env.BANNER_COOKIE_DOMAIN,
      expires: 365,
    })
    this.setState({ hasAcceptedCookies: true })
  }

  hasUserAcceptedCookies() {
    if (process.env.ALWAYS_SHOW_COOKIE_BANNER === 'true') {
      return false;
    }

    return Boolean(Cookies.get(BANNER_COOKIE))
  }

  hideAlert() {
    this.setState({ isAlertVisible: false })

    if (sessionStorage) {
      sessionStorage.setItem('alertDismissed', true)
    }
  }

  get currentNotice() {
    return null;
  }

  get cookiesNotice() {
    return (
      <div style={[STYLES.announcementWrap]}>
        <div style={STYLES.text}>
          We use cookies to help you log in and improve your service. &nbsp;
          <a
            style={STYLES.link}
            href="http://www.aboutcookies.org.uk/managing-cookies"
            rel="noopener noreferrer"
            target="_blank"
          >
            Manage
          </a>
          <span>&nbsp; or &nbsp;</span>
          <button
            onClick={() => {
              this.setCookieAsAccepted()
            }}
            style={STYLES.link}
          >
            Accept
          </button>
        </div>
      </div>
    )
  }

  render() {
    let out = null

    if (!this.state.hasAcceptedCookies && this.state.isEuropeanUnion) {
      out = this.cookiesNotice
    } else if (this.state.isAlertVisible) {
      out = this.currentNotice
    }

    return out
  }
}

export default Radium(NotificationManager)



// WEBPACK FOOTER //
// ./src/components/notification-manager.js